import http from '@/utils/http'
// 用户注册相关接口


// 提交问卷信息
export function questionnaireAdd(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/questionnaire/add`,
    data,
    headers
  }
  return http(config)
}

// 判断是否填写问卷
export function checkSubmitNaire(headers, code) {
  const config = {
    method: 'GET',
    url: `/user/questionnaire/query?feedbackCode=${code}`,
    headers,
  }
  return http(config)
}



// 获取问卷基本信息接口

export function getQuestioniareInfo(headers, code) {
  const config = {
    method: 'GET',
    url: `/user/admin/questionnaire/get/${code}`,
    headers,
  }
  return http(config)
}



// 匿名问卷保存
export function noTokenQuestionnaireAdd(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/questionnaire/anonymous/add`,
    data,
    headers
  }
  return http(config)
}


// 健康承诺书提交
export function addHealthCommitment(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/user/addHealthCommitment`,
    data,
    headers
  }
  return http(config)
}


// 健康承诺书回显
export function getHealthCommitment(headers, meetingCode) {
  const config = {
    method: 'POST',
    url: `/user/user/getHealthCommitment?meetingCode=${meetingCode}`,
    headers
  }
  return http(config)
}




// 数贸会健康承诺书
export function submitGdteHealthCommitment(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/commitment/create`,
    headers,
    data
  }
  return http(config)
}

// 数贸会健康承诺书回显
export function gdteHealthCommitmentShow(headers, meetingCode) {
  const config = {
    method: 'GET',
    url: `/user/commitment/get/${meetingCode}`,
    headers,
  }
  return http(config)
}



// mehz pass卡
export function submitPassRegister(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/pass/submit`,
    headers,
    data
  }
  return http(config)
}


// 自定义表单数据获取

export function getFormData(headers, code) {
  const config = {
    method: 'GET',
    url: `/user/admin/questionnaire/get/${code}`,
    headers,
  }
  return http(config)
}